import type { PermissionFinal } from '@educational-initiatives/bitwise-engine'
import type { PermissionService } from '@core/services/permission-service/permission-service'

/**
 * Grants when IAM enables the permission, or when the permission is absent from the catalog
 * but every known catalog permission is enabled (typical super-admin / full-access users).
 * Denies when the permission exists and is off.
 */
export function canAccessAcademicCalendar(
    permissionService: PermissionService,
    permissionName: string,
): boolean {
    const direct = permissionService.getPermissionByName(permissionName)
    if (direct !== undefined) {
        return direct
    }

    const catalog = permissionService.getCachedBitwisePermissions()
    if (!catalog?.length) {
        return false
    }

    return catalog.every((perm: PermissionFinal) => perm.isEnabled)
}
